import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { routerMiddleware } from 'connected-react-router';
import { persistStore } from 'redux-persist';
import { isProductionEnv } from './utils/platform';
import { persistedReducer, routerHistory } from './slices/rootReducer';
import { isDebugModeEnabled } from './utils/queryParameters';

const middleware = [
  routerMiddleware(routerHistory),
  ...getDefaultMiddleware()
];

const store = configureStore({
  reducer: persistedReducer,
  middleware,
  devTools: isDebugModeEnabled || !isProductionEnv()
});

export const rootState = store.getState();

export const persistor = persistStore(store);

export default store;
